<div
	class="items-center justify-start"
	matDialogTitle
>
	<span>{{ 'utils.sort' | translate }}</span>
	<div class="flex-auto"></div>
	<button
		color="dark"
		mat-icon-button
		matDialogClose
		tabindex="-1"
	>
		<mat-icon>close</mat-icon>
	</button>
</div>
<mat-dialog-content class="mat-dialog-flex-content flex flex-col gap-2">
	<mat-form-field
		appearance="fill"
		class="mat-form-field-no-hint"
	>
		<mat-label translate>utils.groupBy</mat-label>
		<mat-select
			(selectionChange)="this.applyGroup($event.value)"
			[compareWith]="groupTypeComparer"
			[value]="this.group.value.selectedGroup"
		>
			<ng-container>
				<mat-option
					[value]="group"
					*ngFor="let group of groupTypes; let i = index"
				>
					{{ group | translate }}
				</mat-option>
			</ng-container>
		</mat-select>
	</mat-form-field>
</mat-dialog-content>
<mat-dialog-actions
	align="end"
	class="mt-4"
>
	<button
		(click)="applyFilters()"
		[disabled]="this.group.invalid"
		color="primary"
		mat-raised-button
	>
		<span translate>utils.apply-changes</span>
	</button>
</mat-dialog-actions>
